export interface Gift {
  id: string
  giftBundleIds?: string[]
  name: string
  imageUrl: string
  isActive: boolean
}

export const giftConverter: firebase.firestore.FirestoreDataConverter<Gift> = {
  toFirestore: (giftBundle) => {
    return {
      giftBundleIds: giftBundle.giftBundleIds,
      name: giftBundle.name,
      imageUrl: giftBundle.imageUrl,
      isActive: giftBundle.isActive
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      id: snapshot.id,
      giftBundleIds: data.giftBundleIds,
      name: data.name,
      imageUrl: data.imageUrl,
      isActive: data.isActive
    }
  }
}
